import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=ddf9f006&scoped=true&"
import script from "./apply.vue?vue&type=script&lang=js&"
export * from "./apply.vue?vue&type=script&lang=js&"
import style0 from "./apply.vue?vue&type=style&index=0&id=ddf9f006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf9f006",
  null
  
)

export default component.exports